// Documentos legais — conteúdo replicado de duarte-advocacia.com (fonte da firma, PT)
// Estrutura por secções numeradas. blocos: { t: "p" | "ul", v: string | string[] }

export const LEGAL_DOCS = {
  privacidade: {
    eyebrow: "Documento legal",
    title: "Política de Privacidade.",
    subtitle:
      "Como tratamos os seus dados pessoais quando contacta a Duarte Advocacia Internacional, em conformidade com o RGPD e com a Lei n.º 58/2019.",
    updated: "Última atualização · 15 de Maio de 2026",
    sections: [
      {
        n: "01",
        title: "Âmbito e responsável pelo tratamento",
        blocks: [
          { t: "p", v: "A presente Política de Privacidade aplica-se ao tratamento de dados pessoais realizado por Duarte Advocacia Internacional, com sede na Av. da República, nº 18, 3º — 1050-191 Lisboa, no contexto da atividade jurídica, comunicações comerciais e operação do presente site." },
          { t: "p", v: "O responsável pelo tratamento é Rodrigo Duarte, advogado inscrito na Ordem dos Advogados de Portugal com cédula profissional nº 57.039L. Para qualquer questão relativa à proteção de dados, contacte rgpd@duarte-advocacia.com." },
        ],
      },
      {
        n: "02",
        title: "Categorias de dados tratados",
        blocks: [
          { t: "p", v: "Em função do canal e da finalidade, podemos tratar:" },
          { t: "ul", v: [
            "Dados de identificação: nome, cargo, cidade, nacionalidade.",
            "Dados de contato: e-mail, telefone, endereço postal.",
            "Dados profissionais e patrimoniais comunicados voluntariamente no formulário de diagnóstico ou em comunicação direta.",
            "Dados de navegação e técnicos: endereço IP, identificador de sessão, dispositivo, métricas de uso agregadas.",
            "Dados curriculares, quando aplicável a candidaturas espontâneas.",
          ] },
          { t: "p", v: "Apenas tratamos categorias especiais de dados (saúde, antecedentes, situação fiscal pormenorizada) após contratação formal e mediante consentimento expresso ou execução de mandato." },
        ],
      },
      {
        n: "03",
        title: "Finalidades e base jurídica",
        blocks: [
          { t: "ul", v: [
            "Resposta a pedidos de informação e diligenciação prévia à contratação — base: diligências pré-contratuais (art. 6.º, n.º 1, al. b) RGPD).",
            "Prestação de serviços jurídicos contratados — base: execução contratual.",
            "Cumprimento de obrigações legais e regulatórias da Ordem dos Advogados — base: obrigação legal.",
            "Gestão administrativa, contabilística e de cobrança — base: obrigação legal e interesse legítimo.",
            "Comunicação institucional não-promocional — base: interesse legítimo.",
          ] },
        ],
      },
      {
        n: "04",
        title: "Tecnologia, automação e inteligência artificial",
        tag: "Cláusula-base",
        blocks: [
          { t: "p", v: "O escritório poderá utilizar ferramentas tecnológicas, sistemas de automação e soluções de inteligência artificial como apoio à organização interna de informações, gestão de relacionamento, triagem administrativa, melhoria de processos e preparação de comunicações. Essas ferramentas não substituem a análise jurídica humana, não prestam aconselhamento jurídico autónomo e não tomam decisões automatizadas com efeitos jurídicos sobre o titular dos dados." },
          { t: "p", v: "Todas as comunicações jurídicas, propostas e pareceres são revistos por advogado responsável antes de qualquer envio ao cliente. Não existe decisão automatizada, na acepção do art. 22.º do RGPD, que produza efeitos jurídicos sobre o titular dos dados." },
        ],
      },
      {
        n: "05",
        title: "Subcontratantes e transferências",
        blocks: [
          { t: "p", v: "Recorremos a subcontratantes tecnológicos seleccionados pela sua conformidade com o RGPD — designadamente fornecedores de correio eletrônico profissional, sistema de gestão de relação com clientes, armazenamento cifrado e ferramentas de produtividade." },
          { t: "p", v: "Sempre que se verifique transferência de dados para fora do Espaço Econômico Europeu, asseguramos a existência de cláusulas contratuais-tipo aprovadas pela Comissão Europeia ou de uma decisão de adequação." },
        ],
      },
      {
        n: "06",
        title: "Medidas de segurança e acesso interno",
        blocks: [
          { t: "ul", v: [
            "Autenticação em dois factores obrigatória em todas as contas profissionais.",
            "Comunicação exclusiva por canais oficiais — proibido o uso de dispositivos ou contas pessoais.",
            "Acesso a dados de cliente limitado aos profissionais diretamente afetos ao dossiê.",
            "Encriptação em trânsito e em repouso para documentos sensíveis.",
            "Auditoria periódica de acessos e formação anual da equipe em segurança da informação.",
          ] },
        ],
      },
      {
        n: "07",
        title: "Prazo de retenção de dados",
        blocks: [
          { t: "p", v: "Conservamos os dados pelo período estritamente necessário à finalidade que os justifica e, quando aplicável, pelo prazo de conservação imposto pela legislação fiscal, laboral, deontológica e processual." },
          { t: "ul", v: [
            "Pedidos não convertidos em contratação: 12 meses a contar do último contato.",
            "Dossiês de cliente: 10 anos a contar do encerramento, salvo prazo legal superior.",
            "Comunicações administrativas e contabilísticas: prazos legais aplicáveis.",
            "Dados curriculares: 6 meses, salvo consentimento para conservação prolongada.",
          ] },
        ],
      },
      {
        n: "08",
        title: "Direitos do titular dos dados",
        blocks: [
          { t: "p", v: "Nos termos do RGPD, é titular dos direitos de acesso, rectificação, apagamento, limitação do tratamento, portabilidade e oposição. Pode ainda retirar o consentimento, quando aplicável, sem prejuízo da licitude do tratamento realizado anteriormente." },
          { t: "p", v: "Para exercer qualquer destes direitos, contacte-nos por escrito. Responderemos no prazo legal de um mês, prorrogável por dois meses adicionais em casos de complexidade ou volume." },
        ],
      },
      {
        n: "09",
        title: "Envio de documentos sensíveis",
        blocks: [
          { t: "p", v: "Recomendamos vivamente que não envie documentos sensíveis — passaporte, declarações fiscais, certidões pessoais — sem solicitação formal e pelos canais por nós indicados, após contratação ou consulta formal." },
          { t: "p", v: "Documentos enviados espontaneamente, antes de qualquer relação contratual, são tratados sob sigilo profissional e eliminados em prazo razoável caso a relação não evolua." },
        ],
      },
      {
        n: "10",
        title: "Contato e reclamações",
        blocks: [
          { t: "p", v: "Para questões relativas a esta Política ou ao tratamento dos seus dados, contacte: rgpd@duarte-advocacia.com." },
          { t: "p", v: "Tem ainda o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD) — Av. D. Carlos I, 134, 1º — 1200-651 Lisboa — cnpd.pt." },
        ],
      },
    ],
  },

  termos: {
    eyebrow: "Documento legal",
    title: "Termos & Condições.",
    subtitle:
      "Condições de utilização do site www.duarte-advocacia.com e dos seus canais digitais, em conformidade com o Decreto-Lei n.º 7/2004 e legislação aplicável.",
    updated: "Última atualização · 15 de Maio de 2026",
    sections: [
      {
        n: "01",
        title: "Objecto e aceitação",
        blocks: [
          { t: "p", v: "Os presentes Termos e Condições regulam o acesso e a utilização do site institucional da Duarte Advocacia Internacional, Advogado inscrito na Ordem dos Advogados Portuguesa, com sede na Av. da República, nº 18, 3º — 1050-191 Lisboa." },
          { t: "p", v: "A utilização do site implica a aceitação integral dos presentes Termos. Caso não concorde com alguma das cláusulas, deverá abster-se de utilizar o site e os seus formulários." },
        ],
      },
      {
        n: "02",
        title: "Natureza informativa do site",
        tag: "Cláusula-base",
        blocks: [
          { t: "p", v: "As informações disponibilizadas no site têm caráter geral, finalidade meramente informativa e não substituem consulta jurídica individualizada. Nenhum conteúdo aqui disponibilizado constitui, por si só, parecer jurídico, aconselhamento personalizado ou compromisso de atuação." },
        ],
      },
      {
        n: "03",
        title: "Inexistência de relação advogado-cliente",
        tag: "Cláusula-base",
        blocks: [
          { t: "p", v: "O envio de informações através do site, formulários, e-mail ou outros canais digitais não constitui, por si só, relação advogado-cliente, nem implica aceitação automática do caso pelo escritório." },
          { t: "p", v: "A relação advogado-cliente apenas se constitui após (i) confirmação escrita de aceitação do caso pelo Advogado, (ii) celebração de contrato de prestação de serviços jurídicos com âmbito, prazos e honorários acordados, e (iii) verificação de inexistência de conflito de interesses." },
        ],
      },
      {
        n: "04",
        title: "Respostas automáticas e comunicações",
        blocks: [
          { t: "p", v: "Eventuais respostas automáticas geradas pelo site ou pelos seus formulários — incluindo acusos de recebimento, classificações de pedidos ou orientações sumárias — destinam-se exclusivamente à organização interna do escritório e não constituem parecer jurídico." },
          { t: "p", v: "A primeira resposta substantiva, em qualquer caso, é sempre redigida e assinada pelo advogado responsável pelo dossiê." },
        ],
      },
      {
        n: "05",
        title: "Propriedade intelectual e conteúdos",
        blocks: [
          { t: "p", v: "Todos os conteúdos do site — textos, identidade visual, marca, fotografias, ilustrações, código-fonte — são propriedade exclusiva da Duarte Advocacia Internacional ou estão licenciados ao seu uso." },
          { t: "ul", v: [
            "É permitida a consulta e a impressão para uso pessoal e não comercial.",
            "É vedada a reprodução total ou parcial, redistribuição, modificação ou utilização comercial sem autorização escrita.",
            "A reutilização de excertos para fins de citação académica ou jornalística é permitida com indicação clara da fonte.",
          ] },
        ],
      },
      {
        n: "06",
        title: "Hiperligações para terceiros",
        blocks: [
          { t: "p", v: "O site pode conter ligações para sites de terceiros — autoridades públicas, parceiros, fontes legislativas. Não controlamos esses conteúdos e não assumimos responsabilidade pela sua exatidão, disponibilidade ou políticas de privacidade." },
        ],
      },
      {
        n: "07",
        title: "Limitação de responsabilidade",
        blocks: [
          { t: "p", v: "Não nos responsabilizamos por (i) decisões tomadas com base exclusiva na informação geral aqui disponibilizada, (ii) interrupções técnicas, eventuais inexactidões pontuais ou desactualizações momentâneas, (iii) consequências do envio espontâneo de documentos sensíveis fora dos canais oficiais." },
          { t: "p", v: "Esforçamo-nos por manter os conteúdos atualizados e revistos pela equipe jurídica, mas a informação legislativa pode sofrer alterações entre a sua publicação e a leitura." },
        ],
      },
      {
        n: "08",
        title: "Modificações e lei aplicável",
        blocks: [
          { t: "p", v: "Reservamos o direito de modificar os presentes Termos a qualquer momento. A versão em vigor é sempre a publicada no site, com indicação da data da última atualização." },
          { t: "p", v: "Os presentes Termos regem-se pela lei portuguesa. Qualquer litígio será dirimido nos tribunais competentes da comarca de Lisboa, com expressa renúncia a qualquer outro foro." },
        ],
      },
      {
        n: "09",
        title: "Contato",
        blocks: [
          { t: "p", v: "Para questões sobre estes Termos: contato@duarte-advocacia.com · +351 210 534 261 · Av. da República, nº 18, 3º — 1050-191 Lisboa." },
          { t: "p", v: "O responsável pelo tratamento de dados é Rodrigo Duarte. Para qualquer questão relativa à proteção de dados, contacte rgpd@duarte-advocacia.com." },
        ],
      },
    ],
  },

  disclaimer: {
    eyebrow: "Documento legal",
    title: "Disclaimer Jurídico.",
    subtitle:
      "Limites de utilização da informação publicada pela Duarte Advocacia Internacional, em conformidade com o Estatuto da Ordem dos Advogados e legislação aplicável.",
    updated: "Última atualização · 15 de Maio de 2026",
    sections: [
      {
        n: "01",
        title: "Natureza do conteúdo",
        blocks: [
          { t: "p", v: "Todo o conteúdo publicado neste site, nos materiais institucionais da Duarte Advocacia Internacional e nas suas comunicações digitais — incluindo artigos, notas técnicas, FAQ, descrições de área de atuação e publicações em redes sociais — tem natureza informativa e divulgativa." },
          { t: "p", v: "Destina-se a apresentar o escritório, a sua área de prática e a sua visão geral sobre matérias jurídicas relevantes para o público-alvo. Não está adaptado a qualquer caso concreto." },
        ],
      },
      {
        n: "02",
        title: "Não constitui parecer jurídico",
        tag: "Cláusula-base",
        blocks: [
          { t: "p", v: "Nenhum conteúdo publicado constitui parecer jurídico, aconselhamento personalizado ou indicação de atuação para o caso concreto do leitor. A aplicação de qualquer informação aqui contida a uma situação específica deve ser precedida de consulta jurídica formal." },
          { t: "p", v: "Decisões tomadas com base exclusiva em informação geral aqui publicada são da responsabilidade de quem as toma. A Duarte Advocacia Internacional não responde por consequências decorrentes de leituras descontextualizadas ou parciais." },
        ],
      },
      {
        n: "03",
        title: "Atualização e exatidão",
        blocks: [
          { t: "p", v: "O Direito é dinâmico. Legislação, jurisprudência e práticas administrativas — sobretudo em matéria de mobilidade, fiscalidade internacional e Golden Visa — podem alterar-se entre a publicação de um conteúdo e a sua leitura." },
          { t: "ul", v: [
            "Esforçamo-nos por manter os conteúdos revistos pela equipe jurídica.",
            "A data de atualização indicada em cada documento legal é o melhor indicador da sua vigência.",
            "Conteúdos sem data de atualização visível devem ser tratados como meramente indicativos.",
          ] },
        ],
      },
      {
        n: "04",
        title: "Publicações, notas e redes sociais",
        blocks: [
          { t: "p", v: "Eventuais publicações em redes sociais, notas técnicas resumidas ou intervenções em eventos representam a opinião institucional ou pessoal do autor à data da publicação, e não vinculam o escritório a qualquer interpretação futura de matéria semelhante." },
          { t: "p", v: "Comentários, partilhas ou interações nas redes sociais oficiais não constituem canal de prestação de serviços jurídicos." },
        ],
      },
      {
        n: "05",
        title: "Contratação formal",
        blocks: [
          { t: "p", v: "Qualquer análise jurídica vinculativa pressupõe contratação formal do escritório, mediante contrato de prestação de serviços com âmbito, prazos, honorários e responsável identificados." },
          { t: "p", v: "Até esse momento, as comunicações entre o utilizador e o Advogado têm natureza meramente preliminar. Recomendamos não enviar documentos sensíveis sem solicitação formal." },
        ],
      },
      {
        n: "06",
        title: "Documentos complementares",
        blocks: [
          { t: "p", v: "Este Disclaimer deve ser lido em conjunto com a Política de Privacidade e os Termos e Condições. Em caso de contradição aparente entre os três documentos, prevalecem os Termos e Condições." },
          { t: "p", v: "O responsável pelo tratamento de dados é Rodrigo Duarte. Para qualquer questão relativa à proteção de dados, contacte rgpd@duarte-advocacia.com." },
        ],
      },
    ],
  },
};
